import { EDIT_JOB_BASKET } from '@/lib/api.js';
import gtm from '@/lib/gtm';
/**
 *
 * @param {*} path current page user in when login
 * will redirect to Home page in case needed
 */

const actions = {
  async login({ commit }, { Email, Password, RememberMe }) {
    const data = JSON.stringify({
      Password,
      Email,
      RememberMe
    });

    try {
      await this.$auth.loginWith('local', {
        data
      });

      if (this.$auth.user.IsError) {
        throw 'שגיאה';
      }

      commit('SET_AUTH', this.$auth.loggedIn);
      commit('SET_SMART_AGENT_STEP', 2);
      gtm({
        event: 'login',
        userid: this.$auth.user.UserProfile.UserId
      });

      return true;
    } catch (e) {
      console.log(e)
      this.error = e.response;
      commit('SET_AUTH', this.$auth.loggedIn);
      this.$auth.setUserToken('');
      this.$auth.logout();
      return false;
    }
  },

  async updateJobBasket({ commit }, payload) {
    return this.$axios
      .post(`${EDIT_JOB_BASKET}`, payload)
      .then(() => {
        this.$auth.fetchUser();
      })
      .catch(err => {
        let error = new Error(err);
        commit('SET_ERROR', error);
      });
  },

  addJobToFavorites({ commit }, jobCode) {
    if (Number(jobCode) > 0) {
      commit('ADD_JOB_TO_FAVORITES', jobCode);
    }
  },

  addJobsToFavorites({ commit }, jobCode) {
    commit('ADD_JOBS_TO_FAVORITES', jobCode);
  },

  removeJobFromFavorites({ commit }, jobCode) {
    commit('REMOVE_JOB_FROM_FAVORITES', jobCode);
  },
  clearJobBasket({ commit }) {
    commit('CLEAR_JOB_BASKET');
  },
  // smart Agent Data

  addStepOneCategory({ commit }, { cat }) {
    commit('ADD_STEP_1_CATEGORY', { cat });
  },

  addStepOneEmail({ commit }, email) {
    commit('ADD_STEP_1_EMAIL', email);
  },
  setSmartAgentStep({ commit }, step) {
    commit('SET_SMART_AGENT_STEP', step);
  }
};

export default actions;
